import { client } from './client/client.gen'
import { getAuthorizationToken } from './middlewares'

console.log('Setconfig', import.meta.env.VITE_API_URL)

client.setConfig({
  baseUrl: import.meta.env.VITE_API_URL,
  // auth: getAuthorizationToken,
})

client.interceptors.request.use(async config => {
  const token = await getAuthorizationToken()
  if (!token) return config
  config.headers.set('Authorization', `Bearer ${token}`)
  return config
})

// client.TOKEN = async () => (await authenticationService.getAccessToken()) ?? ''

// client.interceptors.request.use(async config => {
//   const token = await getAuthorizationToken()

//   return { ...config, headers: { ...config.headers, Authorization: token } }
// })

// client.interceptors.response.use(refreshIdTokenInterceptor)
